package com.cybersoftsolution.cybersoftsolutionweb.api

import com.cybersoftsolution.cybersoftsolutionweb.models.Values.MY_SECRET_KEY
import kotlin.io.encoding.Base64


fun MutableMap<String, Any?>.buildParams(): String {

    if (isEmpty()) {return ""}

    return this.entries.filter {
        it.value != null
    }.joinToString(prefix = "?",separator = "&") { (key, value) ->
            "$key=$value"
    }.replace("&&","&")
}

